import React from 'react'
import { Form, Button, Card, Container, Row, Col, FloatingLabel, Spinner } from "react-bootstrap";

function LoaderBtn(props) {
    return (
        <>
            <Spinner
                className={ props.loads ===true ? 'visually mx-1' : 'visually-hidden'}
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
            />
        </>
    )
}

export default LoaderBtn